import './applied_filter_view.js.coffee';# Added by Script 
Namespace 'Monitoring.Views.SocialContents.Filters'

class Monitoring.Views.SocialContents.Filters.AppliedGmbAddressesFilterView extends
      Monitoring.Views.SocialContents.Filters.AppliedFilterView
  name: 'gmb_addresses'
  humanize: true
  unmodifiableByModerators: false

  initialize: ({searchQuery}) ->
    super({searchQuery: searchQuery})
    @alias = I18n.t('monitoring.dashboard.filters.gmb_addresses')

  removeFilter: (value) ->
    @searchQuery.removeGmbAddress(value)

  getDescription: (address) ->
    super(address)
